<app-selector
  #selector
  [multiple]="false"
  [type]="type"
  [(ngModel)]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [styles]="styles"
  [displayWithFn]="displayWithFn.bind(this)"
  [optionsFn]="optionsFn.bind(this)"
  newItemLabel="Create License Plate"
  (newItemClick)="on_action_clicked()"
>
</app-selector>